/**
 * This file simply groups different error codes classes to single file for clients to use.
 */
const PzOauthErrorCodes = require('../server/routes/api/pz/oauth/error-codes');
const BffGenericErrorCode = require('../server/routes/api/bff-generic-error-codes');

module.exports = { PzOauthErrorCodes, BffGenericErrorCode };
